import React from "react";
import Grid from "@material-ui/core/Grid";
import HandheldAccounts from "../components/Accounts/HandheldAccounts/HandheldAccounts";
import { ToastContainer } from "react-toastify";
import AddAccountDialog from "../components/Accounts/AddAccountDialog/AddAccountDialog";
import RemoveAccountDialog from "../components/Accounts/RemoveAccountDialog/RemoveAccountDialog";
import OrderAccounts from "../components/Accounts/OrderAccounts/OrderAccounts";
import cloudStore from "../store/CloudStore";
import CloudAccounts from "../components/Accounts/CloudAccounts/CloudAccounts";
import SendEmailDialog from "../components/Accounts/SendEmailDialog/SendEmailDialog";

export default function Accounts() {
  const merchant = cloudStore.merchant;

  const [addAccountDialogType, setAddAccountDialogType] = React.useState(null);
  const [removeAccountDialogType, setRemoveAccountDialogType] = React.useState(null);
  const [sendEmailDialog, setSendEmailDialog] = React.useState(false);
  const [selectedAccount, setSelectedAccount] = React.useState(null);
  const [handheldChange, setHandheldChange] = React.useState(false);
  const [orderChange, setOrderChange] = React.useState(false);
  const [cloudChange, setCloudChange] = React.useState(false);
  const [password, setPassword] = React.useState("");

  function getAddAccountDialogType() {
    return addAccountDialogType;
  }

  function getRemoveAccountDialogType() {
    return removeAccountDialogType;
  }

  function getSelectedAccount() {
    return selectedAccount;
  }

  return (
    <Grid>
      <Grid container direction={"row"} spacing={4}>
        <Grid item lg={4}>
          <HandheldAccounts
            setAddAccountType={setAddAccountDialogType}
            setRemoveAccountType={setRemoveAccountDialogType}
            setSelectedAccount={setSelectedAccount}
            merchant={merchant}
          />
        </Grid>
        <Grid item lg={4}>
          <OrderAccounts
            setAddAccountType={setAddAccountDialogType}
            setRemoveAccountType={setRemoveAccountDialogType}
            setSelectedAccount={setSelectedAccount}
            merchant={merchant}
          />
        </Grid>
        <Grid item lg={4}>
          <CloudAccounts
            setAddAccountType={setAddAccountDialogType}
            setRemoveAccountType={setRemoveAccountDialogType}
            setSelectedAccount={setSelectedAccount}
            merchant={merchant}
            setSendEmailDialog={setSendEmailDialog}
          />
        </Grid>
      </Grid>
      <AddAccountDialog
        getType={getAddAccountDialogType}
        setType={setAddAccountDialogType}
        setHandheldChange={setHandheldChange}
        setOrderChange={setOrderChange}
        setCloudChange={setCloudChange}
        handheldChange={handheldChange}
        orderChange={orderChange}
        cloudChange={cloudChange}
        password={password}
        setPassword={setPassword}
        merchant={merchant}
      />
      <RemoveAccountDialog
        getType={getRemoveAccountDialogType}
        setType={setRemoveAccountDialogType}
        getSelectedAccount={getSelectedAccount}
        setHandheldChange={setHandheldChange}
        setOrderChange={setOrderChange}
        setCloudChange={setCloudChange}
        handheldChange={handheldChange}
        orderChange={orderChange}
        cloudChange={cloudChange}
        merchant={merchant}
      />
      <SendEmailDialog
        setSelectedAccount={setSelectedAccount}
        getSelectedAccount={getSelectedAccount}
        sendEmailDialog={sendEmailDialog}
        setSendEmailDialog={setSendEmailDialog}
        cloudChange={cloudChange}
        setCloudChange={setCloudChange}
        merchant={merchant}
      />
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Grid>
  );
}
